export default "__VITE_ASSET__2cdfe889__"